module.exports = __webpack_public_path__ + "static/img/7.ad2984a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/7.png
// module id = G93T
// module chunks = 0